import React from "react"
import { connect, useDispatch, useSelector } from "react-redux"
import { compose } from "recompose"
import withMobileDialog from "@material-ui/core/withMobileDialog"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { Typography, Button, Box } from "@material-ui/core"
// import InstagramIcon from "@material-ui/icons/Instagram"
import FacebookIcon from "@material-ui/icons/Facebook"
import TwitterIcon from "@material-ui/icons/Twitter"
import LinkedInIcon from "@material-ui/icons/LinkedIn"
import YouTubeIcon from "@material-ui/icons/YouTube"
import { closeIntegrationDialog } from "actions/integrations-dialog"
import DialogsContainerDialog from "../DialogsContainer"
import Hootsuite from "../../assets/hootsuite-icon.svg"
// import Agora from "../../assets/agora-icon.svg"
// import SproutSocial from "../../assets/sprout-icon.svg"
import TweetDeck from "../../assets/tweet-deck-icon.svg"
import { handleConnect } from "utils/handleSocialConnect"

const IntergrationDialog = ({ fullScreen, classes, open, ...props }) => {
  const dispatch = useDispatch()
  const { id, twitter, facebook, linkedin, hootsuite, youtube } = useSelector(
    state => state.organization.currentOrg
  )

  const handleClose = () => {
    dispatch(closeIntegrationDialog())
  }

  const Networks = [
    // {
    //   name: "Instagram",
    //   icon: <InstagramIcon color="secondary"  />,
    //   connected: 0
    // },
    {
      name: "Facebook",
      icon: <FacebookIcon color="secondary" />,
      connected: facebook
    },
    {
      name: "LinkedIn",
      icon: <LinkedInIcon color="secondary" />,
      connected: linkedin
    },
    {
      name: "Twitter",
      icon: <TwitterIcon color="secondary" />,
      connected: twitter
    },
    {
      name: "Youtube",
      icon: <YouTubeIcon color="secondary" />,
      connected: youtube
    }
  ]

  const Platforms = [
    {
      name: "Hootsuite",
      icon: (
        <img src={Hootsuite} style={{ height: "26px" }} alt="hootsuite-icon" />
      ),
      connected: hootsuite
    }
    // {
    //   name: "Sprout Social",
    //   icon: (
    //     <img
    //       src={SproutSocial}
    //       alt="sprout-social-icon"
    //
    //     />
    //   ),
    //   connected: 0
    // },
    // {
    //   name: "TweetDeck",
    //   icon: <img src={TweetDeck} alt="tweet-deck-icon" />,
    //   connected: twitter
    // }
    // {
    //   name: "Agora Pulse",
    //   icon: <img src={Agora} alt="agora-icon"  />,
    //   connected: 0
    // }
  ]

  return (
    <DialogsContainerDialog
      open={open}
      handleClose={handleClose}
      title="Integrations"
      // subtitle="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
      // nonumy"
      content={
        <Box className={classes.networkContainer}>
          <Typography variant="h3" className={classes.social}>
            Social Networks
          </Typography>
          <Box display="flex" flexWrap="wrap" justifyContent="space-between">
            {Networks.map((network, index) => (
              <Box
                key={index}
                className={classes.network}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box
                  display="flex"
                  justifyContent="flex-start"
                  className={classes.networkTextContainer}
                >
                  <Box
                    className={
                      network.connected === -1
                        ? classes.iconCommingSoon
                        : classes.icon
                    }
                  >
                    {network.icon}
                  </Box>

                  <Typography
                    className={
                      network.connected === -1
                        ? classes.networkNameCommingSoon
                        : classes.networkName
                    }
                    variant="h5"
                    color="primary"
                  >
                    {network.name}
                  </Typography>
                </Box>
                <Box className={classes.connectedContainer}>
                  {network.connected === 0 && (
                    <Button
                      className={classes.button}
                      onClick={() => handleConnect(network.name, id)}
                    >
                      Connect
                    </Button>
                  )}
                  {network.connected === 1 && (
                    <Button className={classes.buttonConnected} disabled>
                      Connected
                    </Button>
                  )}
                  {network.connected === -1 && (
                    <Typography className={classes.comingSoomText}>
                      Coming Soon!
                    </Typography>
                  )}
                </Box>
              </Box>
            ))}
          </Box>
          <Typography variant="h3" className={classes.social}>
            Platforms
          </Typography>
          <Box display="flex" flexWrap="wrap" justifyContent="space-between">
            {Platforms.map((platform, index) => (
              <Box
                key={index}
                className={classes.network}
                display="flex"
                justifyContent="space-around"
                alignItems="center"
              >
                <Box display="flex" className={classes.networkTextContainer}>
                  <Box
                    className={
                      platform.connected === -1
                        ? classes.iconCommingSoon
                        : classes.icon
                    }
                  >
                    {platform.icon}
                  </Box>
                  <Typography
                    className={
                      platform.connected === -1
                        ? classes.networkNameCommingSoon
                        : classes.networkName
                    }
                    variant="h5"
                    color="primary"
                  >
                    {platform.name}
                  </Typography>
                </Box>
                <Box className={classes.connectedContainer}>
                  {platform.connected === 0 && (
                    <Button
                      className={classes.button}
                      onClick={() => handleConnect(platform.name)}
                    >
                      Connect
                    </Button>
                  )}
                  {platform.connected === 1 && (
                    <Button className={classes.buttonConnected} disabled>
                      Connected
                    </Button>
                  )}
                  {platform.connected === -1 && (
                    <Typography className={classes.comingSoomText}>
                      Coming Soon!
                    </Typography>
                  )}
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      }
      buttons={
        <div className={classes.buttonsContainer}>
          <Button
            variant="contained"
            color="primary"
            className={classes.okButton}
            type="submit"
            onClick={handleClose}
          >
            OK
          </Button>
        </div>
      }
    />
  )
}

const mapStateToProps = state => {
  return {
    open: state.integrationsDialog.open
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
  withMobileDialog()
)(IntergrationDialog)



// WEBPACK FOOTER //
// ./src/dialogs/Integration/index.jsx